module.exports = __webpack_public_path__ + "static/img/3_pred.43a74ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/index/3_pred.jpg
// module id = 45
// module chunks = 0